<template>
<v-text-field
  data-cy="password-input"
  label="Password"
  name="password"
  prepend-icon="mdi-lock"
  :type="showPassword ? 'text' : 'password'"
  :rules="[rules.required]"
  :value="value"
  @input="$emit('input', $event)"
>
  <template v-slot:append>
    <v-icon data-cy="show-hide-pwd-button" :aria-label="appendIconLabel" @click="showPassword = !showPassword">{{ appendIcon }}</v-icon>
  </template>
</v-text-field>
</template>

<script>
/**
 * A text field to receive a password
 * Includes an 'append-icon' setup to switch the input from text to
 * password type, to show the password in plain text on demand
 */
export default {
  name: 'BaseInputPassword',
  props: {
    /**
     * The password value (if it exists already)
     */
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      /**
       * Whether to show the password in plain text
       */
      showPassword: false,
      /**
       * Validation rules
       */
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
    type: function () { return this.showPassword ? 'text' : 'password' },
    appendIcon: function () { return this.showPassword ? 'mdi-eye' : 'mdi-eye-off' },
    appendIconLabel: function () { return this.showPassword ? 'Hide password' : 'Show password' }
  }
}
</script>

<style scoped>

</style>
